import React, { useContext, useEffect, useRef, useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Iconify from '../iconify';
import {
  AddClientEducationInfo,
  DeleteClientEducationInfo,
  EditClientDetails,
  GetClient,
  GetRoles,
  PostClientEducationInfo,
  PostClientIntendedWorkInfo,
} from '../services/httpServices';

import styled from '@emotion/styled';
import { Trash } from 'react-feather';

// import { TextField } from '@material-ui/core';
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));
const EducationInfo = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  let { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [client, setClient] = useState({});

  const nameOfInstituteRef = useRef('');
  const fielfOfStudyEmpRef = useRef('');
  const cityRef = useRef('');
  const provinceRef = useRef('');
  const countryRef = useRef('');
  const dateFromRef = useRef('');
  const dateToRef = useRef('');

  const fetchClient = async (event) => {
    const client = await GetClient(props.id);
    //console.log('client:', client);
    setClient(client);
    setLoading(false);
  };
  useEffect(() => {
    fetchClient();
  }, [location]);
  // #endregion Refs

  const SaveUser = async (event) => {
    // setPosting(true);
    setLoading(true);
    event.preventDefault();
    //console.log('saveHit');
    const payload = {
      id: props.id,
      nameOfInstitute: nameOfInstituteRef.current.value,
      fieldOfStudy: fielfOfStudyEmpRef.current.value,
      city: cityRef.current.value,
      province: provinceRef.current.value,
      country: countryRef.current.value,
      dateFrom: dateFromRef.current.value,
      dateTo: dateToRef.current.value,
    };

    //console.log(payload);
    let response = await AddClientEducationInfo(id, payload);
    //console.log('PostResponse:', response);

    if (response.status == 200) {
      setLoading(false);
      props.setMessage('Client saved successfully.');
      props.setSaved(true);
      props.setOpen(true);
      let clientSaved = client;
      clientSaved.clientEducationInfos = response.data;
      setClient(clientSaved);
      // setTimeout(() => {
      //   navigate(`/app/EditClient/${response.data.id}`);
      // }, 2000);
    } else {
      props.setMessage(response.data);
      props.setSaved(false);
      props.setOpen(true);
      setLoading(false);
      // setPosting(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };
  const EndDateChangeHandle = () => {
    if (dateFromRef.current.value > dateToRef.current.value) {
      dateToRef.current.value = '';
      alert('End Date should be Greater then start date! ');
    }
  };
  const deleteEducationInfo = async (rowId) => {
    setLoading(true);
    event.preventDefault();
    let response = await DeleteClientEducationInfo(rowId);
    //console.log('RRRRR', response);
    if (response.status == 200) {
      setLoading(false);
      props.setMessage('Client saved successfully.');
      props.setSaved(true);
      props.setOpen(true);
      let clientSaved = client;
      clientSaved.clientEducationInfos = response.data;
      setClient(clientSaved);
    } else {
      props.setMessage(response.data);
      props.setSaved(false);
      props.setOpen(true);
      setLoading(false);
      // setPosting(false);
    }
  };
  return (
    <>
      <form onSubmit={SaveUser}>
        {loading ? (
          <Grid display="flex" alignItems="center" justifyContent="center" height="20vh" container>
            <CircularProgress size={60} thickness={3} value={100} />
          </Grid>
        ) : (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Box component={Paper} p={1}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={4} md={3}>
                    <TextField
                      label="Name of Institute"
                      required
                      variant="outlined"
                      fullWidth
                      size="small"
                      // defaultValue={client?.clientEducationInfos[0]?.nameOfInstitute}
                      inputRef={nameOfInstituteRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    <TextField
                      label="Field Of Study"
                      required
                      variant="outlined"
                      fullWidth
                      size="small"
                      // defaultValue={client?.clientEducationInfos[0]?.fieldOfStudy}
                      inputRef={fielfOfStudyEmpRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    <TextField
                      label="City"
                      required
                      variant="outlined"
                      fullWidth
                      size="small"
                      // defaultValue={client?.clientEducationInfos[0]?.city}
                      inputRef={cityRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    <TextField
                      label="Province"
                      required
                      variant="outlined"
                      fullWidth
                      size="small"
                      // defaultValue={client?.clientEducationInfos[0]?.province}
                      inputRef={provinceRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    <TextField
                      label="Country"
                      required
                      variant="outlined"
                      fullWidth
                      size="small"
                      // defaultValue={client?.clientEducationInfos[0]?.country}
                      inputRef={countryRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    <TextField
                      label="Start Date"
                      type="date"
                      required
                      InputLabelProps={{ shrink: true }}
                      variant="outlined"
                      fullWidth
                      size="small"
                      // onChange={EndDateChangeHandle}
                      // defaultValue={client?.clientEducationInfos[0]?.dateFrom?.split('T')[0]}
                      inputRef={dateFromRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    <TextField
                      label="End Date"
                      type="date"
                      required
                      // onChange={EndDateChangeHandle}
                      InputLabelProps={{ shrink: true }}
                      variant="outlined"
                      fullWidth
                      size="small"
                      // defaultValue={client?.clientEducationInfos[0]?.dateTo?.split('T')[0]}
                      inputRef={dateToRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}></Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    {/* <Button onClick={AddeducationRow} variant="contained">
                      Add
                    </Button> */}
                    <Button type="submit" variant="contained">
                      Save
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <br></br>
              <br></br>
              <TableContainer component={Paper}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Sr#</TableCell>
                      <TableCell>Name Of Institute</TableCell>
                      <TableCell>Field of Study</TableCell>
                      <TableCell>City</TableCell>
                      <TableCell>Province</TableCell>
                      <TableCell>Country</TableCell>
                      <TableCell>Start Date</TableCell>
                      <TableCell>End Date</TableCell>
                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {client?.clientEducationInfos?.map((row, index) => (
                      <TableRow key={index + 1}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{row.nameOfInstitute}</TableCell>
                        <TableCell>{row.fieldOfStudy}</TableCell>
                        <TableCell>{row.city}</TableCell>
                        <TableCell>{row.province}</TableCell>
                        <TableCell>{row.country}</TableCell>
                        <TableCell>{row.dateFrom?.split('T')[0]}</TableCell>
                        <TableCell>{row.dateTo?.split('T')[0]}</TableCell>

                        <TableCell>
                          <IconButton onClick={() => deleteEducationInfo(row.id)} aria-label="delete" size="small">
                            <Trash />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        )}
      </form>
    </>
  );
};

export default EducationInfo;
